import { TYPE_STRING } from './input-types';

export const id = 'customField2';
export const apiKey = 'CustomField2';
export const type = TYPE_STRING;

export const customField2 = {
  id,
  apiKey,
  type,
};
